import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcCollaboration, FcEditImage } from "react-icons/fc";
import { graphicsInfo } from "../../../SchemaInfo/info";

const EditGraphics = () => {
  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState([]);
  const [proofPreview, setProofPreview] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [existingProofs, setExistingProofs] = useState([]);
  const [data, setData] = useState(graphicsInfo);
  const [socialMedia, setSocialMedia] = useState([]);

  const imageInputRef = useRef(null);
  const proofInputRef = useRef(null);

  const { id } = useParams();
  const navigate = useNavigate();

  // ✅ Fetch Data
  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const res = await performRequest("GET", `/graphics/get-graphics/${id}`);
      const apiData = res?.data?.data;

      setData({
        ...graphicsInfo,
        ...apiData,
        uploadImages: [],
        markAsPublished: [],
        platforms: apiData.platforms || [],
      });

      setExistingImages(apiData.images || []);
      setExistingProofs(apiData.proofs || []);
    } catch (err) {
      Toast("error", "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Submit
  const handelSubmit = (values) => {
    setLoading(true);

    let formData = new FormData();

    Object.keys(values).forEach((key) => {
      if (
        key !== "uploadImages" &&
        key !== "platforms" &&
        key !== "markAsPublished" &&
        key !== "rawImage"
      ) {
        formData.append(key, values[key]);
      }
    });

    if (values.rawImage) {
      formData.append("rawImage", values.rawImage);
    }

    values.uploadImages.forEach((file) => {
      formData.append("images", file);
    });

    // existingImages.forEach((img) => {
    //   //   formData.append("existingImages[]", img);
    //   formData.append("existingImages", JSON.stringify(existingImages));
    // });

    // ✅ Existing Images (FIXED)
    formData.append("existingImages", JSON.stringify(existingImages));

    values.platforms.forEach((p) => {
      formData.append("platforms[]", p);
    });

    values.markAsPublished.forEach((file) => {
      formData.append("proofs", file);
    });

    // ✅ Existing Proofs (FIXED)
    formData.append("existingProofs", JSON.stringify(existingProofs));

    performRequest("PATCH", `/graphics/edit-graphics/${id}`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Graphics updated successfully!");
          navigate(`/graphics-view/${id}`);
        } else {
          Toast("error", "Something went wrong");
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingPage />;

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header">
            <h2 className="page-title">
              <FcEditImage /> Edit Graphics Post
            </h2>
            <StepRoutes />
          </div>

          <div className="card my-4">
            <div className="card-header">
              <h3>Edit Graphics</h3>
            </div>

            <Formik
              initialValues={data}
              enableReinitialize={true}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* Branding */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Branding</label>
                      <div className="col">
                        <CustomSelect name="postBranding">
                          <option value="">Select</option>
                          <option>Kryzen Biotech</option>
                          <option>Sudhir Devkar</option>
                          <option>Hydroponic Masterclass</option>
                          <option>Eat Pure Green</option>
                        </CustomSelect>
                      </div>
                    </div>

                    {/* Headline */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Headline</label>
                      <div className="col">
                        <CustomInput name="postHeadline" />
                      </div>
                    </div>

                    {/* Subheading */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">
                        Subheading
                      </label>
                      <div className="col">
                        <CustomInput name="postSubheading" />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Editor Name
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="graphicsEditor">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Deadline</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="taskdedline"
                        ></CustomInput>
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">CTA</label>
                      <div className="col">
                        <CustomInput name="postCta" />
                      </div>
                    </div>

                    {/* CTA Sub */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">CTA Sub</label>
                      <div className="col">
                        <CustomInput name="ctaSubheading" />
                      </div>
                    </div>

                    {/* Raw Image */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Raw Image</label>
                      <div className="col">
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) =>
                            props.setFieldValue("rawImage", e.target.files[0])
                          }
                        />
                      </div>
                    </div>

                    {/* Title */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Title</label>
                      <div className="col">
                        <CustomInput name="postTitle" />
                      </div>
                    </div>

                    {/* Description */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">
                        Description
                      </label>
                      <div className="col">
                        <CustomTextArea name="postDescription" />
                      </div>
                    </div>

                    {/* Post Type */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Post Type</label>
                      <div className="col">
                        <CustomSelect name="postType">
                          <option value="">Select</option>
                          <option>Job Post</option>
                          <option>Product Promotion</option>
                          <option>Carousel</option>
                          <option>BTS</option>
                          <option>Update</option>
                          <option>Review</option>
                        </CustomSelect>
                      </div>
                    </div>

                    {/* Platforms */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Platforms</label>
                      <div className="col">
                        {[
                          "LinkedIn",
                          "YouTube",
                          "Instagram",
                          "Facebook",
                          "Google Photos",
                        ].map((p) => (
                          <label key={p} className="me-3">
                            <input
                              type="checkbox"
                              style={{ width: "18px", height: "18px" }}
                              checked={props.values.platforms.includes(p)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  props.setFieldValue("platforms", [
                                    ...props.values.platforms,
                                    p,
                                  ]);
                                } else {
                                  props.setFieldValue(
                                    "platforms",
                                    props.values.platforms.filter(
                                      (item) => item !== p
                                    )
                                  );
                                }
                              }}
                            />{" "}
                            {p}
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Upload Images */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">Images</label>
                      <div className="col">
                        <input
                          type="file"
                          multiple
                          className="form-control"
                          onChange={(e) => {
                            const files = Array.from(e.target.files);

                            props.setFieldValue("uploadImages", [
                              ...props.values.uploadImages,
                              ...files,
                            ]);

                            const preview = files.map((file) => ({
                              url: URL.createObjectURL(file),
                            }));

                            setImagePreview((prev) => [...prev, ...preview]);
                          }}
                        />

                        <div className="d-flex flex-wrap mt-3">
                          {/* ✅ Existing Images */}
                          {existingImages.map((img, i) => (
                            <div
                              key={`existing-${i}`}
                              style={{ position: "relative", marginRight: 10 }}
                            >
                              <img src={img} width="100" height="100" />

                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  background: "red",
                                  color: "#fff",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const updated = existingImages.filter(
                                    (_, index) => index !== i
                                  );
                                  setExistingImages(updated);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}

                          {/* ✅ New Images */}
                          {imagePreview.map((img, i) => (
                            <div
                              key={`new-${i}`}
                              style={{ position: "relative", marginRight: 10 }}
                            >
                              <img src={img.url} width="100" height="100" />

                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  background: "red",
                                  color: "#fff",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  // 🔥 cleanup memory
                                  URL.revokeObjectURL(imagePreview[i].url);

                                  const updatedFiles =
                                    props.values.uploadImages.filter(
                                      (_, index) => index !== i
                                    );

                                  const updatedPreview = imagePreview.filter(
                                    (_, index) => index !== i
                                  );

                                  props.setFieldValue(
                                    "uploadImages",
                                    updatedFiles
                                  );
                                  setImagePreview(updatedPreview);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Proof Upload */}
                    <div className="mb-3 row">
                      <label className="col-3 w-25 form-label">
                        Mark as Published (Upload proof)
                      </label>
                      <div className="col">
                        <input
                          type="file"
                          multiple
                          className="form-control"
                          onChange={(e) => {
                            const files = Array.from(e.target.files);

                            props.setFieldValue("markAsPublished", [
                              ...props.values.markAsPublished,
                              ...files,
                            ]);

                            const preview = files.map((file) => ({
                              url: URL.createObjectURL(file),
                            }));

                            setProofPreview((prev) => [...prev, ...preview]);
                          }}
                        />

                        <div className="d-flex flex-wrap mt-3">
                          {/* ✅ Existing Proofs */}
                          {existingProofs.map((img, i) => (
                            <div
                              key={`existing-proof-${i}`}
                              style={{ position: "relative", marginRight: 10 }}
                            >
                              <img src={img} width="100" height="100" />

                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  background: "red",
                                  color: "#fff",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const updated = existingProofs.filter(
                                    (_, index) => index !== i
                                  );
                                  setExistingProofs(updated);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}

                          {/* ✅ New Proofs */}
                          {proofPreview.map((img, i) => (
                            <div
                              key={`new-proof-${i}`}
                              style={{ position: "relative", marginRight: 10 }}
                            >
                              <img src={img.url} width="100" height="100" />

                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                  background: "red",
                                  color: "#fff",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  // 🔥 cleanup memory
                                  URL.revokeObjectURL(proofPreview[i].url);

                                  const updatedFiles =
                                    props.values.markAsPublished.filter(
                                      (_, index) => index !== i
                                    );

                                  const updatedPreview = proofPreview.filter(
                                    (_, index) => index !== i
                                  );

                                  props.setFieldValue(
                                    "markAsPublished",
                                    updatedFiles
                                  );
                                  setProofPreview(updatedPreview);
                                }}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer text-end">
                    <FormSubmitButton buttonText="Update Graphics Post" />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditGraphics;
